import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  facebookIcon,
  googleIcon,
  ForgotPasswordCover,
  logo,
  BackwardArrow,
  ArrowUpRightBlue,
} from "../../constant/imagePath";
import { Button } from "../../stories/Button/Button";
import { Input } from "../../stories/Input/Input";
import classes from "./ForgotPasswordPage.module.css";
import { BeforeLoginHeader } from "../../stories/BeforeLoginHeader/BeforeLoginHeader";
import CallMadeIcon from "@mui/icons-material/CallMade";
import { useHistory } from "react-router-dom";
import Colors from "../../stories/assets/Colors";
import Fonts from "../../stories/assets/Fonts";
import { isMobileViewHook } from "../../CustomHooks/isMobileViewHook";
import { MobileHeader } from "../../stories/MobileHeader/MobileHeader";
import { LinkButtonWithIcon } from "../../stories/LinkButtonWithIcon/LinkButtonWithIcon";
import { apiHeader, BaseURL } from "../../Config/apiUrl";
import { toast } from "react-toastify";
import { Post } from "../../Axios/AxiosFunctions";

const ForgotPasswordPage = (props) => {
  const history = useHistory();

  // variables and states
  const [email, setEmail] = useState("");
  const [emailSendSuccess, setEmailSendSuccess] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const [loading, setLoading] = useState(false);
  const sendResetPasswordEmailUrl = BaseURL('auth/passwordReset');

  const handleSendForgotEmailRequest = async() => {
    setLoading(true);
    const Header = await apiHeader(false);
    const data = {
      "email": email,
    };

    const response = await Post(sendResetPasswordEmailUrl, data, Header);
    setLoading(false);
    if (response !== undefined) {
      toast.success('Email sent successfully');
      setEmailSendSuccess(true);
    }
  };

  useEffect(() => {
    isMobileViewHook(setIsMobile);
  }, [window.innerWidth]);

  return (
    <>
      <style jsx>{`
        .${classes.mainHeading} {
          font-size: ${isMobile ? "26px" : Fonts.h3.fontSize};
          line-height: ${isMobile ? "32px" : Fonts.h3.lineHeight};
          font-family: ${isMobile ? Fonts.h2.fontFamily : Fonts.h3.fontFamily};
          color: ${Colors.neutralShadesOfNero};
        }
        .${classes.subText} {
          font-size: ${Fonts.p1.fontSize};
          line-height: ${Fonts.p1.lineHeight};
          font-family: ${Fonts.p1.fontFamily};
          color: ${Colors.neutralShadesOfDimGray};
        }
      `}</style>
      <div className={` ${[classes.ForgotPasswordPage].join(" ")}`}>
        <div className={`container-fluid ${classes.container}`}>
          {isMobile ? (
            <MobileHeader
              isLogo={true}
              isAvatar={false}
              customStyle={{ padding: "0px " }}
            />
          ) : (
            <BeforeLoginHeader
              onClick={() => {
                history.push({ pathname: "welcome" });
              }}
              icon={logo}
              text1={"Don’t have an account?"}
              text2={"Get started"}
              goBackOnClick={() => history.goBack()}
            />
          )}

          <div className="row" style={{ height: "100%" }}>
            <div
              className={`p-0 col-md-6 ${[
                classes.innerContainer,
                classes.imageContainer,
              ].join(" ")}`}
            >
              <img className="img-fluid d-block" src={ForgotPasswordCover} />
            </div>
            <div
              className={`col-md-6 ${[
                classes.innerContainer,
                classes.rightContainer,
              ].join(" ")}`}
            >
              {emailSendSuccess ? (
                <>
                  <div className={classes.goBack}>
                    <LinkButtonWithIcon
                      leftIcon={BackwardArrow}
                      text={"Go back"}
                      iconStyle={{ marginRight: "16px" }}
                    />
                  </div>

                  <h3 className={`${[classes.mainHeading].join(" ")}`}>
                    Check your email
                  </h3>
                  <span className={`${[classes.subText].join(" ")}`}>
                    Instructions to reset your password have been sent to{" "}
                    <span style={{ color: Colors.neutralShadesOfNero }}>
                      {email}
                    </span>
                    {"\n"} {"\n"}
                    If no email is received within ten minutes, check that the
                    submitted address is correct.
                  </span>
                  <div className={classes.btnMt32} />
                  <Button
                    primary={true}
                    disabled={false}
                    size={"Large"}
                    label={"Back to sign in"}
                    onClick={() => {
                      history.push({ pathname: "login" });
                    }}
                  />
                </>
              ) : (
                <>
                  <div className={classes.goBack}>
                    <LinkButtonWithIcon
                      leftIcon={BackwardArrow}
                      text={"Go back"}
                      iconStyle={{ marginRight: "16px" }}
                    />
                  </div>

                  <h3 className={`${[classes.mainHeading].join(" ")}`}>
                    Forgot password?
                  </h3>
                  <span className={` ${[classes.subText].join(" ")}`}>
                    Enter the email address you used when you joined and we’ll
                    send you instructions to reset your password.
                  </span>
                  <form className="col-md-12">
                    <div className={classes.emailInputBox}>
                      <Input
                        type={"email"}
                        label={"Email"}
                        state={email}
                        setter={setEmail}
                      />
                    </div>
                    <div className={classes.btnMt32}>
                      <Button
                        primary={true}
                        disabled={loading}
                        customStyle={{ ...Fonts.b1, width: "100%" }}
                        // disabled={email !== "" ? false : true}
                        size={"Large"}
                        label={"Send password reset instructions"}
                        onClick={() => {
                          handleSendForgotEmailRequest();
                        }}
                      />
                    </div>
                  </form>
                </>
              )}
            </div>
            {/* Footer */}
            {/* Dont have an account for mobile */}
            <div className={`col-sm-12 ${classes.footerContainer}`}>
              <div className={classes.dontHaveAccountForMobile}>
                <p
                  style={{
                    ...Fonts.p2,
                    color: Colors.neutralShadesOfDimGray,
                  }}
                >
                  Don’t have an account?
                </p>
                <LinkButtonWithIcon
                  primary={true}
                  text={"Get Started"}
                  rightIcon={ArrowUpRightBlue}
                  iconStyle={{ margin: "0px" }}
                  onClick={() => history.push("/welcome")}
                />
              </div>
            </div>
            {/*  */}
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgotPasswordPage;
